import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { firebaseApp, isFirebaseConfigured } from '../firebase/config';
import {
  attemptAdminLogin,
  DEMO_EMAIL,
  DEMO_PASSWORD,
} from '../auth/attemptAdminLogin';

const AdminLogin = () => {
  const navigate = useNavigate();
  const demoMode = !isFirebaseConfigured() || !firebaseApp;
  const [credentials, setCredentials] = useState(() => ({
    email: demoMode ? DEMO_EMAIL : '',
    password: demoMode ? DEMO_PASSWORD : '',
  }));
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const result = await attemptAdminLogin(credentials.email, credentials.password);
    setIsLoading(false);

    if (result.ok) {
      navigate('/dashboard', { replace: true });
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F5EFE6' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-extrabold mb-3 tracking-tight" style={{ color: '#1A1A1A' }}>
            Admin Panel
          </h1>
          <p className="text-lg font-medium" style={{ color: '#4A4A4A' }}>
            Jatin Interiors Management System
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div
            className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center"
            style={{ backgroundColor: '#C8A96A' }}
          >
            <span className="material-symbols-outlined text-white text-3xl">admin_panel_settings</span>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-semibold mb-2" style={{ color: '#1A1A1A' }}>
                Email
              </label>
              <div className="relative">
                <span
                  className="material-symbols-outlined absolute left-3 top-1/2 transform -translate-y-1/2"
                  style={{ color: '#6B7280' }}
                >
                  email
                </span>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={credentials.email}
                  onChange={handleInputChange}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors font-medium"
                  placeholder="Enter email"
                  style={{ color: '#1A1A1A' }}
                  autoComplete="username"
                  required
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-semibold mb-2" style={{ color: '#1A1A1A' }}>
                Password
              </label>
              <div className="relative">
                <span
                  className="material-symbols-outlined absolute left-3 top-1/2 transform -translate-y-1/2"
                  style={{ color: '#6B7280' }}
                >
                  lock
                </span>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleInputChange}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors font-medium"
                  placeholder="Enter password"
                  style={{ color: '#1A1A1A' }}
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>

            {error && (
              <div className="p-3 rounded-lg bg-red-50 border border-red-200" role="alert">
                <p className="text-sm font-medium text-red-700">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-3 rounded-lg font-bold transition-all duration-300 text-white hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed text-lg"
              style={{ backgroundColor: '#C8A96A' }}
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="material-symbols-outlined animate-spin">refresh</span>
                  Signing in...
                </span>
              ) : (
                'Sign In'
              )}
            </button>
          </form>

          <div className="mt-6 p-4 rounded-lg bg-gray-50 border border-gray-200">
            <p className="text-sm font-bold mb-2" style={{ color: '#1A1A1A' }}>
              Sign-in options
            </p>
            <p className="text-xs leading-relaxed" style={{ color: '#4A4A4A' }}>
              {isFirebaseConfigured() && firebaseApp ? (
                <>
                  Use your Firebase admin email and password, or the built-in demo admin:{' '}
                  <span className="font-mono">{DEMO_EMAIL}</span> / <span className="font-mono">{DEMO_PASSWORD}</span>.
                </>
              ) : (
                <>
                  No Firebase keys in <span className="font-mono">.env.local</span> — demo login only:{' '}
                  <span className="font-mono">{DEMO_EMAIL}</span> / <span className="font-mono">{DEMO_PASSWORD}</span>.
                  Override with <span className="font-mono">REACT_APP_DEMO_ADMIN_EMAIL</span> and{' '}
                  <span className="font-mono">REACT_APP_DEMO_ADMIN_PASSWORD</span>.
                </>
              )}
            </p>
          </div>
        </div>

        <div className="text-center mt-6">
          <p className="text-sm font-medium" style={{ color: '#6B7280' }}>
            © 2024 Jatin Interiors. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
